import { render } from "./BaseTableFilter.vue?vue&type=template&id=4bf41353"
import script from "./BaseTableFilter.vue?vue&type=script&lang=js"
export * from "./BaseTableFilter.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__